import React from 'react';
import {  useNavigate } from 'react-router-dom';

function Ham({isOpen, onDimHover, categoryList, onMenuClick}){
  const navigate = useNavigate();
  
  // isOpen이 false면 아무것도 렌더링하지 않음
  if (!isOpen) return null;

  // 메인 카테고리 클릭
  const handleMainMenuClick = (category) => {
    if (onMenuClick) {
      onMenuClick(category.category_name);
    }
    navigate(`/category/cinemaPage?title=${encodeURIComponent(category.category_name)}&category_code=${category.category_code}`);
    onDimHover();
  };

  // 서브 카테고리 클릭
  const handleSubMenuClick = (mainCategory, subCategory) => {
    if (onMenuClick) {
      onMenuClick(mainCategory.category_name); // 상위 카테고리 클릭 상태 유지
    }
    navigate(`/category/cinemaPageSec?title=${encodeURIComponent(subCategory.category_name)}&mainCategory=${encodeURIComponent(mainCategory.category_name)}&category_code=${subCategory.category_code}`);
    onDimHover();
  };

  return(
    <div>
        {isOpen && (
          <div className="hamburger-dropdown">
            <div style={{width: '100%', background: 'white', height: '45vh'}}>
              <div className="hamburger_inner">
                <div className="dropdown-content">
                {/* 기존 코드 - Purpose 카테고리 포함
                {categoryList && categoryList.map((category) => (
                  <div key={category.category_seq} className="category-column">
                    <h3>
                      {category.category_name === 'PURPOSE' ? (
                        <button style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                          {category.category_name}
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={() => handleMainMenuClick(category)}
                          style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                        >
                          {category.category_name}
                        </button>
                      )}
                    </h3>
                    
                    {category.category2 && (
                      <ul className='sub_cate'>
                        {category.category2.map((sub) => (
                          <li key={sub.category_seq}>
                            <button
                              type="button"
                              onClick={() => handleSubMenuClick(category, sub)}
                              style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
                            >
                              {sub.category_name}
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
                */}
                
                {/* 새로운 코드 - Purpose 카테고리 제외 */}
                {categoryList && categoryList
                  .filter(category => 
                    category.category_name !== 'Purpose' && 
                    category.category_name !== 'BRAND'
                  ) // Purpose와 BRAND 카테고리 제외
                  .map((category) => (
                  <div key={category.category_seq} className="category-column">
                    <h3>
                      <button
                        type="button"
                        onClick={() => handleMainMenuClick(category)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                      >
                        {category.category_name}
                      </button>
                    </h3>
                    
                    {category.category2 && (
                      <ul className='sub_cate'>
                        {category.category2.map((sub) => (
                          <li key={sub.category_seq}>
                            <button
                              type="button"
                              onClick={() => handleSubMenuClick(category, sub)}
                              style={{ background: 'none', border: 'none', padding: 0, margin: 0, cursor: 'pointer' }}
                            >
                              {sub.category_name}
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
                </div>
              </div>
            </div>
            <div className='menu_dim' onMouseEnter={onDimHover}/>
          </div>
        )}
    </div>
  )
};

export default Ham;